import { Nullable } from '@/shared/types/app.types'

export enum CommonSynopticTypeOptions {
    TITLE = 'TITLE',
    VARIABLE_TEXT = 'VARIABLE_TEXT',
    VARIABLE_NUMBER = 'VARIABLE_NUMBER',
    VARIABLE_PERCENTAGE = 'VARIABLE_PERCENTAGE',
    VARIABLE_DATE = 'VARIABLE_DATE',
    VARIABLE_IMAGE = 'VARIABLE_IMAGE'
}

export enum CommonSynopticTypeChildSelection {
    NONE = 'NONE',
    SINGLE_SELECTION = 'SINGLE_SELECTION',
    MULTIPLE_SELECTION = 'MULTIPLE_SELECTION'
}

export interface CommonSynopticTemplateTree {
    allowsChildrenSelection: string
    children: Nullable<CommonSynopticTemplateTree[]>
    code: string
    morphologicCodeId: Nullable<number>
    nodeType: string
    required: boolean
    text: string
    topographicCodeId: Nullable<number>
}

export interface CommonSynopticTemplatesLaboratory {
    labId: number
    labName: string
    labExternalId: string
    labActive: boolean
}

export interface CommonSynopticTemplate {
    id: number
    laboratory: CommonSynopticTemplatesLaboratory
    active: boolean
    title: string
    tree: CommonSynopticTemplateTree[]
}
